module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTW05-35Thin.11133588.woff";